(() => {
  const SEL = {
  tpl: "[data-km-float-template]",
  root: "[data-km-float]",
  btnOpen: "[data-km-float-open]",
  btnClose: "[data-km-float-close]",
  hint: "[data-km-float-hint]"
};

  const getPath = () => (location.pathname || "/").replace(/\/+$/, "") || "/";

  function pageType() {
    const p = getPath();
    if (p === "/" || p === "") return "home";
    if (p.startsWith("/products/")) return "product";
    if (p.startsWith("/collections/")) return "collection";
    if (p.startsWith("/pages/")) return "page";
    if (p.startsWith("/blogs/")) {
      const parts = p.split("/").filter(Boolean);
      return parts.length >= 3 ? "article" : "blog";
    }
    if (p.startsWith("/cart")) return "cart";
    if (p.startsWith("/search")) return "search";
    return "all";
  }

  function parseLines(s) {
    return String(s || "")
      .split("\n")
      .map(v => v.trim())
      .filter(Boolean);
  }

  function norm(p) {
    p = (p || "").trim();
    if (!p) return "";
    if (!p.startsWith("/")) p = "/" + p;
    return p.replace(/\/+$/, "");
  }

  function matchPath(rules, path) {
    const p = norm(path);
    return rules.some(r => {
      const rr = norm(r);
      if (!rr) return false;
      return p === rr || p.startsWith(rr + "/") || p.startsWith(rr);
    });
  }

  function shouldShow(el) {
    const showOn = (el.getAttribute("data-show-on") || "all").trim();
    const t = pageType();
    if (showOn !== "all" && showOn !== t) return false;

    const mode = (el.getAttribute("data-pages-mode") || "all").trim();
    const rules = parseLines(el.getAttribute("data-pages"));
    const path = getPath();

    if (mode === "all" || rules.length === 0) return true;

    const hit = matchPath(rules, path);
    if (mode === "include") return hit;
    if (mode === "exclude") return !hit;

    return true;
  }

  function storageKey(el) {
    // por loja + (opcional) por sectionId se você quiser no futuro
    return `km:floating_video:closed:${location.host}`;
  }

  function isClosedRemembered(el) {
    const remember = el.getAttribute("data-remember-close") === "true";
    if (!remember) return false;
    try {
      return localStorage.getItem(storageKey(el)) === "1";
    } catch (e) {
      return false;
    }
  }

  function rememberClosed(el) {
    const remember = el.getAttribute("data-remember-close") === "true";
    if (!remember) return;
    try {
      localStorage.setItem(storageKey(el), "1");
    } catch (e) {}
  }

  function teleportToBody(el) {
    // se já moveu, não faz de novo
    if (el.__kmTeleported) return;
    el.__kmTeleported = true;

    // ✅ move pra dentro do body (fora do header DOM)
    // mantendo o elemento idêntico (listeners vão ser aplicados depois)
    document.body.appendChild(el);
  }

  function showHint(el) { el.classList.add("km-float--hint-on"); }
  function hideHint(el) { el.classList.remove("km-float--hint-on"); }

  function openWithEngine({ src, muted }) {
    if (window.KMVideoEngine && typeof window.KMVideoEngine.openSingle === "function") {
      window.KMVideoEngine.openSingle({ src, muted });
      return true;
    }
    if (window.KMVideoEngine && typeof window.KMVideoEngine.open === "function") {
      window.KMVideoEngine.open({ src, muted });
      return true;
    }
    return false;
  }

  function openVideo(el) {
  const src = (el.getAttribute("data-src") || "").trim();
  if (!src) return;

  const muted = el.getAttribute("data-muted") === "true";

  // ✅ abre quando o engine estiver pronto (sem polling)
  if (window.KMVideoEngine && window.KMVideoEngine.__ready) {
    openWithEngine({ src, muted });
    return;
  }

  const onReady = () => {
    openWithEngine({ src, muted });
  };

  document.addEventListener("km:video:ready", onReady, { once: true });

  // fallback de segurança (caso o evento nunca dispare)
  setTimeout(() => {
    openWithEngine({ src, muted });
  }, 1500);
}

  function initOne(el) {
    if (el.__kmInit) return;
    el.__kmInit = true;

    // ✅ teleporta primeiro (evita interferência no header)
    // filtros
if (!shouldShow(el) || isClosedRemembered(el)) {
  el.style.display = "none";
  return;
}

// ✅ só teleporta se realmente vai exibir
teleportToBody(el);

    const btnOpen = el.querySelector(SEL.btnOpen);
    const btnClose = el.querySelector(SEL.btnClose);
    const hint = el.querySelector(SEL.hint);

    if (btnOpen) {
      // Desktop hover/focus
      btnOpen.addEventListener("mouseenter", () => hint && showHint(el));
      btnOpen.addEventListener("mouseleave", () => hideHint(el));
      btnOpen.addEventListener("focusin", () => hint && showHint(el));
      btnOpen.addEventListener("focusout", () => hideHint(el));

      // Mobile: mostra tooltip por 1.2s ao tocar
      let t;
      btnOpen.addEventListener("touchstart", () => {
        if (!hint) return;
        showHint(el);
        clearTimeout(t);
        t = setTimeout(() => hideHint(el), 1200);
      }, { passive: true });

      // click abre modal
      btnOpen.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  openVideo(el);
});
    }

    if (btnClose) {
      btnClose.addEventListener("click", (e) => {
  e.preventDefault();
  e.stopPropagation();
  rememberClosed(el);
  el.style.display = "none";
});
    }
  }

  function initAll() {
    document.querySelectorAll(SEL.root).forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
